import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root',
})
export class TvService {
  
  private dataMenuTvSelected = new BehaviorSubject<any>(null);
  dataMenuTvSelected$ = this.dataMenuTvSelected.asObservable();

  menuTvUrl = environment.avatarUrl + "/caremoni-tv-app/menu-tv.json";
  //menuTvUrl = "../../../assets/menu-tv-local.json";

  setDataMenuTvShow(data: any) {
    this.dataMenuTvSelected.next(data); 
  }

  getDataMenuTvSelectedSnapshot() {
    return this.dataMenuTvSelected.getValue();
  }

  async getDataMenuTv(): Promise<any>{
    const response = await fetch(this.menuTvUrl);
    if (!response.ok) throw new Error("HTTP error! status: " + response.status);  
    return await response.json();
  }
 
}
